// src/service/ImportantInfoService.js

import {getUserType} from "./Enums";

const getImportantInfos = async (user) => {
    const userType = getUserType(user);
    if (!userType) {
        return [];
    }

    // Retourner les informations importantes en fonction du type d'utilisateur
    if (userType === "admin") {
        return [{ code: "CC" }];
    } else if (userType === "user") {
        return [{ code: "DD" }];
    }

    return [];
};

export default {
    getImportantInfos,
};